@if (progress(); as progress) {
  <aside
    class="sm-app-update-progress"
    role="region"
    aria-labelledby="sm-app-update-progress-title">
    <div class="sm-app-update-progress__heading">
      <p id="sm-app-update-progress-title" class="sm-app-update-progress__title">
        {{ 'appUpdate.downloading' | translate }}
      </p>

      @if (progress.percentage !== null) {
        <span class="sm-app-update-progress__percentage" aria-hidden="true">
          {{ progress.percentage }}%
        </span>
      }
    </div>

    <ion-progress-bar
      class="sm-app-update-progress__bar"
      [type]="progress.percentage === null ? 'indeterminate' : 'determinate'"
      [value]="progress.percentage === null ? 0 : progress.percentage / 100"
      [attr.aria-label]="'appUpdate.downloadProgressAriaLabel' | translate"
      [attr.aria-valuemin]="progress.percentage === null ? null : 0"
      [attr.aria-valuemax]="progress.percentage === null ? null : 100"
      [attr.aria-valuenow]="progress.percentage">
    </ion-progress-bar>

    <span class="sm-app-update-progress__announcement" aria-live="polite" aria-atomic="true">
      @if (progress.announcedPercentage === null) {
        {{ 'appUpdate.downloading' | translate }}
      } @else {
        {{ 'appUpdate.downloadingProgress' | translate: {percentage: progress.announcedPercentage} }}
      }
    </span>
  </aside>
}
